import styled from 'styled-components';

export const Divider = styled.hr`
  border: 0.5px solid ${props => props.theme.palette.neutral[300]};
  border-radius: 2px;
  width: 100%;
`;
